module.exports = __webpack_public_path__ + "static/robotsim2-6c47c884b469e1007f5d3792de59b635.jpg";